import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import 'src/styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AMPLIFY_CONFIG } from 'src/constants';
import { DBErrorMonitor } from './services/error-monitor';

Amplify.configure(AMPLIFY_CONFIG);
DBErrorMonitor.init();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
